export const scrapUndefinedValuesFromObject = <T extends Record<string, unknown>>(obj: T) => {
    const newObj: Record<string, unknown> = {};
    for(const [key,value] of Object.entries(obj)) {
        if (value !== undefined) {
            newObj[key] = value;
        }
    }
    return newObj;
}

type PrimitiveKeys<T> = {
    [K in keyof T]: T[K] extends string | number | boolean ? K : never;
}[keyof T];

export function deduplicateObjectArray<T, K extends PrimitiveKeys<T>>(items: T[], key: K): { item: T, duplicates: number }[] {
    return items.reduce<{ item: T, duplicates: number }[]>((acc, item) => {
        const existing = acc.find(i => i.item[key] === item[key]);
        if (existing) {
            existing.duplicates += 1;
        } else {
            acc.push({ item, duplicates: 0 });
        }
        return acc;
    }, []);
}

export const removeEmptyArraysFromNestedObject = <T extends Record<string, Record<string, Array<unknown>>>>(
    data: T
): T => {
    const cleaned = {} as T;

    for (const [outerKey, outerValue] of Object.entries(data)) {
        if (typeof outerValue !== 'object' || outerValue === null) {
            cleaned[outerKey as keyof T] = outerValue as T[keyof T];
            continue;
        }

        const cleanedInner: Record<string, Array<unknown>> = {};

        for (const [innerKey, innerValue] of Object.entries(outerValue)) {
            if (Array.isArray(innerValue) && innerValue.length > 0) {
                cleanedInner[innerKey] = innerValue;
            }
        }

        cleaned[outerKey as keyof T] = cleanedInner as T[keyof T];
    }

    return cleaned;
};